module.exports = __webpack_public_path__ + "img/badge.7903b06e.png";